import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { Select } from "antd";
import { savecompaniesId } from "redux/auth-reducer";
import { useDispatch } from "react-redux";
import { ActiveUsersService } from "apis/Services/ActiveUsersService";
import { AuthStorage } from "utils/auth-storage";

const HandleAuthData = () => {
  const { access_token, company_id, company_name, refresh_token, email } =
    useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [selectedCompanyIdIndex, setSelectedCompanyIdIndex] = useState(null);

  const fetchUserAccessLevels = async (selectedCompanyId) => {
    try {
      let code = AuthStorage.getItem("token");
      let loginEmail = AuthStorage.getItem("email");
      const company_id = selectedCompanyId || AuthStorage.getItem("company_id");
      let data = {
        company_id: company_id,
        loginEmail,
        code,
      };

      const res = await ActiveUsersService.UserInfo(data);
      return res;
    } catch (err) {
      console.log("Error fetching user access levels:", err);
      return null;
    }
  };

  // Function to get the first available company page based on permissions
  const getCompanyRedirectPath = (companyId, accessLevels) => {
    const companyPermissions = accessLevels?.companyAccessLevel;

    if (!companyPermissions) {
      // Default to projects if no permissions found
      return `/main/company/${companyId}/projects`;
    }

    // Define the priority order of company pages
    const pageOrder = [
      { key: "Projects", path: "projects" },
      { key: "Company Admin", path: "company-overview" },
      { key: "Company Reports", path: "company-reports" },
      { key: "Permissions", path: "user-permission" },
      { key: "HiLyte", path: "hilyte" },
      { key: "Warehouse", path: "warehouse-dashboard" },
    ];

    // Find the first available page with access level > 0
    for (const page of pageOrder) {
      const accessLevel = parseInt(companyPermissions[page.key] || "0");
      if (accessLevel > 0) {
        return `/main/company/${companyId}/${page.path}`;
      }
    }

    // Fallback to projects if no page has access level > 0
    return `/main/company/${companyId}/projects`;
  };

  const handleCompanySelect = (selectedOption) => {
    setSelectedCompanyIdIndex(selectedOption);
  };

  const names = company_name.slice(2, -2).split("',");

  const companiesObject = {};

  for (let i = 0; i < names.length; i++) {
    companiesObject[names[i]] = JSON.parse(company_id)[i];
  }

  function sanitizeKeys(obj) {
    const sanitizedObject = {};
    for (const key in obj) {
      if (key.includes("'")) {
        const sanatize = key.replace("'", "");
        sanitizedObject[sanatize] = obj[key];
      }
      // if (key.startsWith("'") && key.endsWith("'")) {
      //   const sanitizedKey = key.slice(1, -1);
      //   sanitizedObject[sanitizedKey] = obj[key];
      // }
      else {
        sanitizedObject[key] = obj[key];
      }
    }
    return sanitizedObject;
  }

  const sanitizedObject = sanitizeKeys(companiesObject);

  useEffect(() => {
    AuthStorage.completeLogin({
      email,
      token: access_token,
      refreshToken: refresh_token,
      lastRequestTime: new Date().getTime(),
      companies_object: JSON.stringify(sanitizedObject),
    });
    const pathname = location.pathname;
    let splitURL = pathname.split("/");
    // console.log(splitURL, "split");

    let slice = splitURL.slice(0, 4);
    // console.log(slice, "slice");
    const newURL = pathname.split("/").slice(0, 4).join("/") + "/j/r/e";
    navigate(newURL);
    // console.log(pathname);
  }, []);

  useEffect(() => {
    const selectCompany = async () => {
      if (selectedCompanyIdIndex !== null) {
        const selectedCompanyId = sanitizedObject[selectedCompanyIdIndex];

        dispatch(savecompaniesId(sanitizedObject));
        AuthStorage.setItem("company_id", selectedCompanyId);

        const accessLevels = await fetchUserAccessLevels(selectedCompanyId);
        const redirectPath = getCompanyRedirectPath(
          selectedCompanyId,
          accessLevels,
        );
        navigate(redirectPath);
      }
    };

    selectCompany();
  }, [selectedCompanyIdIndex]);

  const selectOptions = Object.keys(sanitizedObject).map((name) => ({
    value: name,
    label: name,
  }));

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        width: "100%",
        height: "50vh",
      }}
    >
      <h3>Select a Company</h3>
      <Select
        style={{ width: "200px" }}
        options={selectOptions}
        value={selectOptions[selectedCompanyIdIndex]}
        onChange={handleCompanySelect}
      />
    </div>
  );
};

export default HandleAuthData;
